export default "4 dispositifs cumulables pour financer la trajectoire OPERAT -40 % 2030 sur vos immeubles tertiaires ≥ 1 000 m² : CEE BAT, Coup de pouce CVC, suramortissement, prêts Bpifrance.";
